module.exports = __webpack_public_path__ + "static/media/leaf-white.b7530bdf.svg";